module.exports = __webpack_public_path__ + "static/media/icon-company.52c9e804.svg";